import { defineMessages } from 'react-intl';

/**
 * Intl messages for the presentational `FeedbackButtons` component used on the
 * Estimate (step 3) and Summary (step 5) screens of the UBP Q4 calculator.
 */
export const messages = defineMessages({
	label: {
		id: 'ubp.calculator.feedbackButtons.label',
		defaultMessage: 'Did you find this page helpful?',
	},
	thumbsUpAriaLabel: {
		id: 'ubp.calculator.feedbackButtons.thumbsUpAriaLabel',
		defaultMessage: 'Yes, this page was helpful',
	},
	thumbsDownAriaLabel: {
		id: 'ubp.calculator.feedbackButtons.thumbsDownAriaLabel',
		defaultMessage: 'No, this page was not helpful',
	},
	thanksAfterVote: {
		id: 'ubp.calculator.feedbackButtons.thanksAfterVote',
		defaultMessage: 'Thanks for your feedback!',
	},
});
